import { LotNumberRequest } from "@gtpl/shared-models/production-management";

export class UpdateServiceRemarksDto{
    assetServiceId: number;
    remarks?:string;
}